export const campaignHu = {
  campaign: {
    title: 'E-mail kampányok',
    subtitle: 'Kampányok létrehozása, kezelése és statisztikája',
    new: 'Új kampány',
    // Status
    statusDraft: 'Piszkozat',
    statusScheduled: 'Ütemezett',
    statusSending: 'Küldés folyamatban',
    statusSent: 'Elküldve',
    statusPaused: 'Szüneteltetve',
    statusCancelled: 'Megszakítva',
    // Type
    typeEmail: 'E-mail',
    typeSms: 'SMS',
    // List
    name: 'Kampány neve',
    type: 'Típus',
    status: 'Státusz',
    recipients: 'Címzettek',
    createdAt: 'Létrehozva',
    sentAt: 'Elküldve',
    actions: 'Műveletek',
    noCampaigns: 'Még nincs kampány. Hozd létre az elsőt!',
    // Builder
    builderTitle: 'Kampány létrehozása',
    stepDetails: 'Részletek',
    stepAudience: 'Célközönség',
    stepContent: 'Tartalom',
    stepSchedule: 'Ütemezés',
    stepReview: 'Ellenőrzés',
    // Details step
    campaignName: 'Kampány neve',
    campaignNamePlaceholder: 'pl. Téli promóció',
    campaignType: 'Kampány típusa',
    // Audience step
    audienceType: 'Célközönség típusa',
    audienceAll: 'Minden ügyfél',
    audienceGroup: 'Ügyfélcsoport',
    audienceFiltered: 'Szűrt ügyfelek',
    audienceManual: 'Manuális kiválasztás',
    selectGroups: 'Csoportok kiválasztása',
    estimatedRecipients: 'Becsült címzettek száma',
    // Content step
    subject: 'Tárgy',
    subjectPlaceholder: 'E-mail tárgya',
    preheader: 'Előnézeti szöveg',
    preheaderPlaceholder: 'Rövid összefoglaló...',
    body: 'E-mail tartalom',
    bodyPlaceholder: 'Írd meg az e-mail tartalmát...',
    fromName: 'Feladó neve',
    replyTo: 'Válasz cím',
    templateSelect: 'Sablon kiválasztása',
    noTemplate: 'Nincs sablon',
    // Schedule step
    sendNow: 'Küldés azonnal',
    scheduleLater: 'Ütemezett küldés',
    scheduledAt: 'Küldés időpontja',
    timezone: 'Időzóna',
    // Review step
    reviewTitle: 'Kampány ellenőrzése',
    reviewName: 'Név',
    reviewType: 'Típus',
    reviewAudience: 'Célközönség',
    reviewContent: 'Tartalom',
    reviewSchedule: 'Ütemezés',
    // Actions
    save: 'Mentés',
    saveDraft: 'Mentés piszkozatként',
    send: 'Küldés',
    cancel: 'Mégse',
    back: 'Vissza',
    next: 'Tovább',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    duplicate: 'Duplikálás',
    // Stats
    statsTitle: 'Statisztika',
    statsTotal: 'Összes címzett',
    statsSent: 'Elküldve',
    statsDelivered: 'Kézbesítve',
    statsOpened: 'Megnyitva',
    statsClicked: 'Kattintva',
    statsBounced: 'Visszapattant',
    statsFailed: 'Sikertelen',
    statsUnsubscribed: 'Leiratkozott',
    openRate: 'Megnyitási arány',
    clickRate: 'Kattintási arány',
    deliveryRate: 'Kézbesítési arány',
    // Messages
    createSuccess: 'Kampány sikeresen létrehozva',
    createError: 'Hiba a kampány létrehozásakor',
    deleteConfirm: 'Biztosan törlöd ezt a kampányt?',
    deleteWarning: 'Ez a művelet nem vonható vissza.',
    sendConfirm: 'Biztosan elindítod a kampányt?',
    sendWarning: 'A küldés elindítása után nem módosítható a tartalom.',
  },
};
